import { useState } from 'react';
import type { MutableRefObject } from 'react';
import type { MemoizedFn } from 'memoize-one';
import memoizeOne from 'memoize-one';

export const useDuplicateRef = (): MemoizedFn<
	(
		ref: React.RefCallback<HTMLElement> | React.MutableRefObject<HTMLElement | null> | null,
		duplicatedRef: MutableRefObject<HTMLElement | null>,
	) => (node: HTMLElement | null) => void
> => {
	const [createDuplicateRef] = useState(() =>
		memoizeOne(
			(
				ref: React.RefCallback<HTMLElement> | React.MutableRefObject<HTMLElement | null> | null,
				duplicatedRef: MutableRefObject<HTMLElement | null>,
			) => {
				return (node: HTMLElement | null) => {
					if (typeof ref === 'function') {
						ref(node);
					} else if (ref) {
						ref.current = node;
					}
					duplicatedRef.current = node;
				};
			},
		),
	);

	return createDuplicateRef;
};
